<template>
    <div>
        <v-icon small v-if="item[header.value]" color="success">mdi-check-bold</v-icon>
        <v-icon small v-else color="error">mdi-close-thick</v-icon>
    </div>
</template>

<script setup>

import { defineProps } from 'vue'

const props = defineProps({
    header: { type: Object, required: true },
    item: { type: Object, required: true },
})

</script>